import React, { useState } from "react";
import { ChevronRight, ChevronDown, Phone } from "lucide-react";
import logo from "../../Assets/images/ldc_logo_new.png";
import { capitalizeWords } from "../Common/CommonFunction";
import { Typography, Select, Button,Grid, Spin } from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  DownOutlined,
} from "@ant-design/icons";
const { Title } = Typography;

function SecondStep(props) {
  // console.log("propsSecondHealthBooking", props.data)
  const [selectedDuration, setSelectedDuration] = useState({
    duration: 1,
    gender: "no_preference",
    language: { label: "English", value: "1" },
  });
    const { useBreakpoint } = Grid;
      const screens = useBreakpoint();

  function appointmentForm(type) {
    // console.log("Selected type:", type);
    props.secondCallback(selectedDuration, type); 
  }

  const healthScreenName = props.data?.productCategory?.title || "Health Screen";
  const productId = props.data?.non_gp_product_id;

  function getProductName(id) {
    let products;
  
    // Try to load from localStorage and parse to object
    const stored = localStorage.getItem('nongroupproductid');
    if (stored) {
      try {
        products = JSON.parse(stored); // parse string to object
      } catch (e) {
        console.error("Invalid JSON in localStorage");
        products = {}; // fallback to empty object on error
      }
    } else {
      // Fallback if nothing in localStorage
      products = {
        201: "Vital",
        202: "Bronze",
        203: "Silver",
        204: "Gold",
        205: "Platinum",
        4: "Vital (15 minutes)",
        5: "Bronze (60 minutes)",
        6: "Gold (90 minutes)",
        7: "Silver (75min)",
        10: "Platinum",
        18: "r888",
        20: "r888178",
        22: "Diamond"
      };
    }
  
    return products[id] || `Product ${id}`;
  }
  

  return (
    <>
      <div
        style={{
          background: "#00838540",
          padding: 10,
          marginBottom: 20,
          maxWidth: "605px",
          margin: "auto",
          marginTop: screens.md ? "50px" : "0px",
        }}
      >
        <Title level={4} style={{ margin: 0, color: "#008385",
          // fontFamily:"Lato",
          fontWeight:"400" }} className="textalign">
          {/* {capitalizeWords("Appointment type")}: */}
          Appointment type:

        </Title>
      </div>
      <div style={{ height:screens.md ? "20px" : "20px" }}></div>
      <div
        className="summuryCard"
        style={{
          borderColor: "#008385",
          maxWidth: 393,
          marginInline: 10,
          height: "auto",
          minHeight: 53,
          margin: "auto",
          textAlign: "center"
        }}
      >
        {/* Only show the new dynamic product name */}
        <div>
          {healthScreenName}, {getProductName(productId)}
        </div>
      </div>
      <div style={{ height:screens.md ? "32px" : "20px" }}></div>

      <div
        style={{
          background: "#00838540",
          padding: 10,
          marginBottom: 20,
          marginTop: "50px",
          maxWidth: "605px",
          margin: "auto",
        }}
      >
        <Title level={4} style={{ margin: 0, color: "#008385",
          // fontFamily:"Lato",
          fontWeight:"400" }} className="textalign">
          {/* {capitalizeWords("Booking Preference:")} */}
          Booking preference:
        </Title>
        </div>

      <div className="bottem" style={{padding:"0px",position:"relative"}}>
         <Button
                  shape="square"
                  icon={
                    <ArrowLeftOutlined style={{ color: "#008385", fontSize: "18px" }} />
                  }
                  style={{
                    backgroundColor: "#C8E6E6", // Light teal
                    border: "none",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 10,
                    marginRight: 10,
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    position: "absolute",
                    top: screens.md ? "0px" : "80px",
                    left: 10
                  }}
                  onClick={() => props.data.isbackcheck()}
                />
        {!props?.loading?<div className="bottomButtons" style={{ alignItems: "center" }}>
          <Button
            className="transparentBtn"
            onClick={() => appointmentForm("PreferredTimeclinic")}
          >
         <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
          {/* <span> {capitalizeWords("Book at")}</span>
          <span>{capitalizeWords("preferred clinic")}</span> */}
          <span> {"Book at"}</span>
          <span>{"preferred clinic"}</span>
          </div>          </Button>
          <Button
            className="transparentBtn"
            style={{  width: 182, height: 60 }}
            onClick={() => appointmentForm("PreferredTime")}
          >
          <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
          {/* <span> {capitalizeWords("Book at")}</span>
          <span>{capitalizeWords("preferred time")}</span> */}
            <span> {"Book at"}</span>
            <span>{"preferred time"}</span>
          </div>          </Button>
        </div>:<Spin className="custom-spinner" />}
      </div>
    </>
  );
}

export default SecondStep;